import { css } from '@emotion/core';
var _ref = {
  name: "m6v9vd",
  styles: "max-width:inherit;"
};
export var propertyFeatures = isEmbedded => /*#__PURE__*/css("max-width:400px;", isEmbedded && _ref);
var _ref2 = {
  name: "gyp8mm",
  styles: "visibility:hidden;"
};
export var divider = _ref3 => {
  var noDivider = _ref3.noDivider;
  return /*#__PURE__*/css("margin:10px;", noDivider && _ref2);
};
export var selectorWrapper = {
  name: "1uk1gs8",
  styles: "margin:0;"
};